import React from 'react';

/**
 * SectionCard - titled card with an optional toolbar slot and a body that
 * can opt into "flush" (no padding) for full-width tables.
 *
 * Props:
 *   title     string
 *   subtitle  string
 *   toolbar   node    rendered top-right (filter pills, buttons, etc.)
 *   flush     bool    when true, removes body padding (use for tables)
 *   className string
 */
export default function SectionCard({ title, subtitle, toolbar, flush, className = '', children }) {
  const bodyClass = flush
    ? 'billing-admin__section-body billing-admin__section-body--flush'
    : 'billing-admin__section-body';
  const showHeader = title || subtitle || toolbar;
  return (
    <div className={`billing-admin__section ${className}`}>
      {showHeader && (
        <div className="billing-admin__section-header">
          <div>
            {title && <h3 className="billing-admin__section-title">{title}</h3>}
            {subtitle && <p className="billing-admin__section-subtitle">{subtitle}</p>}
          </div>
          {toolbar && <div className="billing-admin__section-toolbar">{toolbar}</div>}
        </div>
      )}
      <div className={bodyClass}>{children}</div>
    </div>
  );
}
